import styled from 'styled-components';
import { LAPTOP_SIZE, SMALL_TEXT } from '../../constants/index';

import { func, shape, string } from 'prop-types';

const StyledLangText = styled.div`
  cursor: pointer;
  font-weight: 400;
  font-size: ${SMALL_TEXT};
  color: ${({ color }) => color};
  &:hover {
    opacity: 0.75;
  }
  @media (max-width: ${LAPTOP_SIZE}) {
    margin-left: 25px;
    border-radius: 5px;
    padding: 6px;
    width: 39px;
    border: 1.5px solid;
    font-weight: 500;
  }
`;

const LanguagePicker = ({ selectedLang, toggle, color }) =>
  selectedLang.value === 'cs' ? (
    <StyledLangText color={color} onClick={() => toggle('en')}>
      EN
    </StyledLangText>
  ) : (
    <StyledLangText color={color} onClick={() => toggle('cs')}>
      CS
    </StyledLangText>
  );

LanguagePicker.propTypes = {
  toggle: func.isRequired,
  color: string.isRequired,
  selectedLang: shape({ value: string.isRequired, label: string.isRequired })
    .isRequired,
};

export default LanguagePicker;



// WEBPACK FOOTER //
// components/shared/LanguagePicker.js